import React from "react";

import { Flex, Box, P, Button } from "ui-components";
import { buttonThemes } from "ui-components/theme";
import { gotoUrl } from "utils/helpers";
import FormattedMessage from "components/FormattedMessage";
import { makeSelectQuilAppSettings } from "ducks/selectors";
import { useSelector } from "react-redux";
import get from "lodash/get";

const _imageStyle = {
  width: 250,
  mt: 40
};

const _messageStyle = {
  mt: 57,
  mx: 20,
  textAlign: "center !important",
  fontWeight: "bold"
};

const backgroundColor = `${buttonThemes?.purple?.color} !important`;
const hoverColor = `${buttonThemes?.purple?.hoverColor} !important`;
const _buttonStyle = {
  background: backgroundColor,
  color: "#FFF",
  borderColor: backgroundColor,
  minWidth: "10rem !important",
  py: 12,
  borderRadius: 23,
  ":hover": {
    background: hoverColor,
    borderColor: hoverColor
  }
};

const Maintenance = ({ errorPagesConfig }) => {
  const quiltappSettings = useSelector(makeSelectQuilAppSettings());
  const { action = {} } = quiltappSettings;
  const config = errorPagesConfig?.["maintenance"] || {};
  const errorImage =
    get(action, "data.overlay_screen.image_web_url", "") ||
    config.image ||
    "/assets/images/cl-maintenance.png";
  const imageStyle = { ..._imageStyle, ...(config.imageStyle || {}) };
  const imageAlt = config.imageAlt || "maintenance";
  const message =
    quiltappSettings?.description || config.message || "maintenance_message";
  const messageStyle = { ...(config.messageStyle || {}), ..._messageStyle };
  const buttonText = config.buttonText || "retry";
  const buttonStyle = { ..._buttonStyle, ...(config.buttonStyle || {}) };
  const redirectUrl = config.configUrl || "/web/signup";

  const handleRedirectOnClick = () => {
    gotoUrl(redirectUrl, true, { relaunch: true }, false, false, true);
  };

  return (
    <Flex alignItems="center" flexDirection="column">
      <Box sx={imageStyle}>
        <img alt={imageAlt} src={errorImage} width="100%" height="auto" />
      </Box>
      <P sx={messageStyle}>
        <FormattedMessage html id={message} />
      </P>
      <Box sx={{ mt: 20 }}>
        <Button sx={buttonStyle} onClick={handleRedirectOnClick}>
          <FormattedMessage id={buttonText} />
        </Button>
      </Box>
    </Flex>
  );
};

export default Maintenance;
